export default "<p>authcallback works!</p>\n"